import styled from "styled-components";

interface ISideMenuProps {
  disabled?: boolean;
}

export const SideMenuOptionContainer = styled.div<ISideMenuProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .menuOption {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

    display: flex;
    width: 100%;
    padding: 1rem;
    margin: 0 0.5rem;
    gap: 1rem;

    align-items: center;

    border-radius: 0.5rem;

    transition: 0.3s ease-in-out all;

    h2 {
      transition: 0.3s ease-in-out all;

      margin-bottom: 0;
    }

    &.active,
    :hover {
      background: ${({ theme }) => theme.groups.activeSectionModeration};

      h2 {
        color: ${({ theme }) => theme.groups.primaryText};
      }

      svg path {
        fill: ${({ theme }) => theme.groups.primaryText};
      }
    }
  }

  .text {
    width: 100%;
  }

  .menu-option-report {
    cursor: pointer;

    display: flex;
  }

  svg path {
    transition: 0.3s ease-in-out all;
    fill: ${({ theme }) => theme.controlPanel?.textControlPanel};
  }

  .main-icon {
    display: flex;
    align-items: center;
  }

  .icon {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.controlPanel?.textControlPanel};
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.controlPanel?.textControlPanel};
  }

  .subtitle {
    font-size: 14px;
    font-weight: 400;
    color: #b3b3b3;
  }

  @media screen and (max-width: 1099px) {
    .icon {
      width: 16px;
      height: 16px;
    }

    .title {
      font-size: 14px;
    }
  }
`;
